/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { strings } from '../../../../intl/Strings';
import { logger } from '../../../../shared';
import { LftCountdownAction, LftCountdownActionId, getIconForActionId } from '../shared';

export const LftCountdownBrainstormActionCard: LftCountdownAction = {
    id: LftCountdownActionId.BrainStormDialog,
    primaryContent: strings.getString('lftSidePaneTrialCountDownBrainstormCardText'),
    icon: getIconForActionId(LftCountdownActionId.BrainStormDialog),
    onClick: () => logger.logInfo('LaunchBrainstormDialog', 'User clicked on brainstorm card.')
};
